import { useEffect, useMemo, useState } from 'react';

import crypto from 'crypto';

import { useApolloClient } from '~/techstyle-shared/react-graphql';

import { getGqlPricingMap } from './gqlUtils';

export default function useInitialProductPricing({
  dispatch,
  key,
  initialProducts,
  useDelayedPricing,
  isVip,
}) {
  const apolloClient = useApolloClient();
  const [initialProductsWithPricing, setInitialProductsWithPricing] = useState(
    {}
  );
  const [productPricingMap, setProductPricingMap] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const cacheKey = useMemo(
    () =>
      crypto
        .createHash('sha256')
        .update(
          JSON.stringify({
            initialProducts,
          })
        )
        .digest('hex'),
    [initialProducts]
  );

  useEffect(() => {
    const getInitialProductPricing = async () => {
      if (!initialProducts?.products?.length) {
        return;
      }

      setIsLoading(true);

      const gqlPricingMap = await getGqlPricingMap({
        products: initialProducts?.products,
        apolloClient,
        isVip,
      });

      const newPricingMap = {
        productPricingMap,
        ...gqlPricingMap,
      };

      setProductPricingMap(newPricingMap);

      const productListingData = {
        ...initialProducts,
        products: initialProducts?.products?.map((product) => {
          return {
            ...product,
            ...productPricingMap[product.masterProductId],
          };
        }),
      };
      setInitialProductsWithPricing({
        ...initialProductsWithPricing,
        [cacheKey]: productListingData,
      });

      dispatch({
        type: 'UPDATE_PRODUCTS',
        payload: [productListingData],
        payloadKey: key,
      });

      setIsLoading(false);
    };

    if (useDelayedPricing && !initialProductsWithPricing[cacheKey]) {
      getInitialProductPricing();
    }
  }, [
    cacheKey,
    initialProductsWithPricing,
    initialProducts,
    apolloClient,
    dispatch,
    key,
    productPricingMap,
    useDelayedPricing,
    isVip,
  ]);

  return {
    initialProductsWithPricing: initialProductsWithPricing[cacheKey],
    productPricingMap,
    isLoading,
  };
}
